var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cancelShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "cancelShare" } }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("language.common.attention")))]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.cancelShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cancel-all-content" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("language.popup.cloudExploerPopup.cancelMyShareTask")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cancel-all-footer" }, [
            _c("div", { staticClass: "cancel-all-footer-left" }, [
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      _vm.cancelShow = false
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "language.popup.cloudExploerPopup.cancelMyShareNot"
                      )
                    )
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cancel-all-footer-right" }, [
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("language.popup.cloudExploerPopup.cancelMyShareOk")
                    )
                  )
                ]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9203b560", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9203b560","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_exploer_popups/cancel_share_popup.vue
// module id = null
// module chunks = 